import React from 'react';
import { Link, TextField, useRecordContext } from 'react-admin';
import { CODES_RESOURCE_NAME as CODES_RESOURCE } from '../../codes.dataProvider';
import { codesFields } from '../../codes.model';
import logger from '../../../utils/logger';
const CodeLinkField = ({ addLabel = true, ...props }) => {
    const record = useRecordContext(props);
    
    if (!record) return null;

    // Debug logging
    // logger.log('CodeLinkField record:', record);
    
    const id = record[codesFields.id];
    const name = record[codesFields.codeName];
    
    if (!id) return 'n/a';

    return (
        <Link to={`/${CODES_RESOURCE}/${id}/show`}>
            <span style={{ 
                color: 'var(--mui-palette-primary-main)',
                textDecoration: 'underline'
            }}>
                {id}
            </span>
        </Link>
    );
};

export default CodeLinkField;
